import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Clock, RefreshCw, Info, Lock, CreditCard } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';
// --- Custom Bespoke SVG Illustrations for Extras ---
const DishwasherIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1607">
    <rect x="12" y="12" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-1608" />
    <rect x="16" y="16" width="32" height="8" rx="2" fill="#2BBCB3" data-id="element-1609" />
    <rect x="16" y="28" width="32" height="20" rx="2" fill="#E8F6F5" data-id="element-1610" />
    <circle cx="24" cy="38" r="6" fill="#F5C842" data-id="element-1611" />
    <circle cx="40" cy="38" r="6" fill="#F5C842" data-id="element-1612" />
    <path d="M16 28 L48 28" stroke="#1B1B2F" strokeWidth="2" data-id="element-1613" />
  </svg>;
const LaundryIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1614">
    <rect x="14" y="10" width="36" height="44" rx="4" fill="#1B1B2F" data-id="element-1615" />
    <rect x="18" y="14" width="28" height="8" rx="2" fill="#2BBCB3" data-id="element-1616" />
    <circle cx="32" cy="36" r="12" fill="#E8F6F5" data-id="element-1617" />
    <circle cx="32" cy="36" r="8" fill="#2BBCB3" fillOpacity="0.3" data-id="element-1618" />
    <circle cx="22" cy="18" r="2" fill="#1B1B2F" data-id="element-1619" />
    <circle cx="28" cy="18" r="2" fill="#1B1B2F" data-id="element-1620" />
  </svg>;
const OvenIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1621">
    <rect x="12" y="14" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-1622" />
    <rect x="16" y="18" width="32" height="10" rx="2" fill="#2BBCB3" data-id="element-1623" />
    <rect x="16" y="32" width="32" height="18" rx="2" fill="#E8F6F5" data-id="element-1624" />
    <rect x="22" y="36" width="20" height="10" rx="1" fill="#1B1B2F" data-id="element-1625" />
    <circle cx="20" cy="23" r="2" fill="#1B1B2F" data-id="element-1626" />
    <circle cx="28" cy="23" r="2" fill="#1B1B2F" data-id="element-1627" />
    <circle cx="36" cy="23" r="2" fill="#1B1B2F" data-id="element-1628" />
    <circle cx="44" cy="23" r="2" fill="#1B1B2F" data-id="element-1629" />
  </svg>;
const FridgeIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1630">
    <rect x="16" y="8" width="32" height="48" rx="4" fill="#1B1B2F" data-id="element-1631" />
    <rect x="20" y="12" width="24" height="16" rx="2" fill="#2BBCB3" data-id="element-1632" />
    <rect x="20" y="30" width="24" height="22" rx="2" fill="#E8F6F5" data-id="element-1633" />
    <rect x="24" y="16" width="2" height="8" fill="#1B1B2F" data-id="element-1634" />
    <rect x="24" y="34" width="2" height="12" fill="#1B1B2F" data-id="element-1635" />
  </svg>;
const GarageIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1636">
    <path d="M8 28 L32 12 L56 28 L56 52 L8 52 Z" fill="#1B1B2F" data-id="element-1637" />
    <rect x="16" y="32" width="32" height="20" fill="#E8F6F5" data-id="element-1638" />
    <rect x="16" y="36" width="32" height="2" fill="#2BBCB3" data-id="element-1639" />
    <rect x="16" y="42" width="32" height="2" fill="#2BBCB3" data-id="element-1640" />
    <rect x="16" y="48" width="32" height="2" fill="#2BBCB3" data-id="element-1641" />
    <path d="M44 24 L52 16 L54 18 L46 26 Z" fill="#F5C842" data-id="element-1642" />
    <circle cx="52" cy="16" r="3" fill="#2BBCB3" data-id="element-1643" />
  </svg>;
const BlindsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1644">
    <rect x="16" y="12" width="32" height="6" rx="1" fill="#1B1B2F" data-id="element-1645" />
    <rect x="18" y="22" width="28" height="4" fill="#2BBCB3" data-id="element-1646" />
    <rect x="18" y="30" width="28" height="4" fill="#2BBCB3" data-id="element-1647" />
    <rect x="18" y="38" width="28" height="4" fill="#2BBCB3" data-id="element-1648" />
    <rect x="18" y="46" width="28" height="4" fill="#2BBCB3" data-id="element-1649" />
    <rect x="42" y="18" width="2" height="36" fill="#1B1B2F" data-id="element-1650" />
    <circle cx="43" cy="54" r="3" fill="#F5C842" data-id="element-1651" />
  </svg>;
const CabinetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1652">
    <rect x="12" y="12" width="40" height="40" rx="2" fill="#1B1B2F" data-id="element-1653" />
    <rect x="14" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-1654" />
    <rect x="33" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-1655" />
    <rect x="27" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-1656" />
    <rect x="35" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-1657" />
  </svg>;
const WindowsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1658">
    <rect x="16" y="12" width="32" height="40" rx="2" fill="#1B1B2F" data-id="element-1659" />
    <rect x="20" y="16" width="10" height="16" fill="#E8F6F5" data-id="element-1660" />
    <rect x="34" y="16" width="10" height="16" fill="#E8F6F5" data-id="element-1661" />
    <rect x="20" y="34" width="10" height="14" fill="#E8F6F5" data-id="element-1662" />
    <rect x="34" y="34" width="10" height="14" fill="#E8F6F5" data-id="element-1663" />
    <path d="M20 16 L30 32 M34 16 L44 32" stroke="#2BBCB3" strokeWidth="2" strokeOpacity="0.5" data-id="element-1664" />
  </svg>;
// --- Main Component ---
export function MoveInOutForm() {
  // Step 3 State
  const [moveType, setMoveType] = useState('Move-In');
  const [parking, setParking] = useState('Free on street');
  const [pets, setPets] = useState('None');
  // Step 4 State (Extras)
  const [selectedExtras, setSelectedExtras] = useState<string[]>([]);
  const toggleExtra = (id: string) => {
    setSelectedExtras(prev => prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]);
  };
  const extrasList = [{
    id: 'dishwasher',
    label: 'Washing dishes',
    icon: DishwasherIcon
  }, {
    id: 'laundry',
    label: 'Laundry (wash & fold)',
    icon: LaundryIcon
  }, {
    id: 'oven',
    label: 'Inside of oven',
    icon: OvenIcon
  }, {
    id: 'fridge',
    label: 'Inside of fridge',
    icon: FridgeIcon
  }, {
    id: 'garage',
    label: 'Garage Sweep',
    icon: GarageIcon
  }, {
    id: 'blinds',
    label: 'Wet Wipe Blinds',
    icon: BlindsIcon
  }, {
    id: 'cabinets',
    label: 'Inside Cabinets',
    icon: CabinetsIcon
  }, {
    id: 'windows',
    label: 'Windows',
    icon: WindowsIcon
  }];
  // Step 5 State
  const [frequency, setFrequency] = useState('One time');
  // Step 6 State
  const [selectedDate, setSelectedDate] = useState('04/04');
  const [selectedTime, setSelectedTime] = useState('14:00');
  const dates = [{
    day: 'M',
    date: '30/03'
  }, {
    day: 'Tu',
    date: '31/03'
  }, {
    day: 'W',
    date: '01/04'
  }, {
    day: 'Th',
    date: '02/04'
  }, {
    day: 'F',
    date: '03/04'
  }, {
    day: 'Sa',
    date: '04/04'
  }, {
    day: 'Su',
    date: '05/04'
  }];
  // Step 7 State
  const [paymentMethod, setPaymentMethod] = useState('By Credit/Debit Card');
  // Helper for Step Headings
  const StepHeading = ({
    number,
    title,
    subtitle
  }: {
    number: string;
    title: string;
    subtitle?: string;
  }) => <div className="mb-8" data-id="element-1665">
      <div className="flex items-center gap-4 mb-2" data-id="element-1666">
        <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center text-white font-heading font-bold text-xl shadow-md shrink-0" data-id="element-1667">
          {number}
        </div>
        <h3 className="text-2xl md:text-3xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-1668">
          {title}
        </h3>
      </div>
      {subtitle && <p className="text-gray-500 text-base ml-14 pb-4 border-b border-gray-100" data-id="element-1669">
          {subtitle}
        </p>}
      {!subtitle && <div className="ml-14 pb-4 border-b border-gray-100" data-id="element-1670"></div>}
    </div>;
  return <main className="min-h-screen bg-light pb-24" data-id="element-1671">
      <SEOHead title="Book Move-In / Move-Out Cleaning | Smith & Jengs" description="Professional move-in and move-out cleaning in Bicester. We clean your old or new home top to bottom so it's spotless and ready." data-id="element-1672" />
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-1673">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-1674"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-1675">
          {/* Breadcrumb */}
          <div className="text-sm font-medium text-white/50 mb-6 uppercase tracking-wider" data-id="element-1676">
            <Link to="/" className="hover:text-accent transition-colors" data-id="element-1677">
              Home
            </Link>
            <span className="mx-2" data-id="element-1678">/</span>
            <Link to="/services" className="hover:text-accent transition-colors" data-id="element-1679">
              Our Services
            </Link>
            <span className="mx-2" data-id="element-1680">/</span>
            <span className="text-accent" data-id="element-1681">Book Online</span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1682">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight mb-4" data-id="element-1683">
              Move-In / Move-Out
            </h1>
            <p className="text-xl md:text-2xl font-serif italic text-white/60" data-id="element-1684">
              Book Online in 60 Seconds
            </p>
          </motion.div>
        </div>
      </section>

      {/* Form & Sidebar Container */}
      <div className="container mx-auto px-6 md:px-12 -mt-8 relative z-20" data-id="element-1685">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-1686">
          {/* Main Form Area */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8 xl:col-span-9 bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-1687">
            <div className="text-center mb-16 flex flex-col items-center" data-id="element-1688">
              <div className="w-24 h-24 rounded-full border-2 border-accent/20 flex items-center justify-center mb-6 bg-accent/5" data-id="element-1689">
                <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1690">
                  <rect x="16" y="24" width="32" height="28" rx="2" fill="#1B1B2F" data-id="element-1691" />
                  <path d="M16 24 L32 12 L48 24 Z" fill="#2BBCB3" data-id="element-1692" />
                  <rect x="24" y="32" width="16" height="4" fill="#E8F6F5" data-id="element-1693" />
                  <path d="M32 32 L32 44 M26 38 L38 38" stroke="#F5C842" strokeWidth="3" strokeLinecap="round" data-id="element-1694" />
                </svg>
              </div>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary uppercase tracking-wide mb-3" data-id="element-1695">
                Move-In / Move-Out Cleaning
              </h2>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto" data-id="element-1696">
                It only takes 60 seconds to Book your Home Cleaning!
              </p>
              <span className="text-accent text-sm font-bold uppercase tracking-widest mt-4" data-id="element-1697">
                Move-In / Move-Out Cleaning
              </span>
            </div>

            <form className="space-y-20" onSubmit={e => e.preventDefault()} data-id="element-1698">
              {/* STEP 1 */}
              <section data-id="element-1699">
                <StepHeading number="1" title="Contact Information" data-id="element-1700" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-1701">
                  <input type="text" placeholder="First Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1702" />
                  <input type="text" placeholder="Last Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1703" />
                  <input type="email" placeholder="Email" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1704" />
                  <div className="flex rounded-xl border border-gray-200 bg-gray-50 focus-within:bg-white focus-within:ring-2 focus-within:ring-accent focus-within:border-accent transition-all overflow-hidden" data-id="element-1705">
                    <div className="px-4 py-4 border-r border-gray-200 bg-gray-100 flex items-center justify-center text-gray-600 font-medium" data-id="element-1706">
                      🇬🇧 ▾
                    </div>
                    <input type="tel" placeholder="Phone Number" className="w-full px-5 py-4 outline-none bg-transparent text-primary" data-id="element-1707" />
                  </div>
                </div>
              </section>

              {/* STEP 2 */}
              <section data-id="element-1708">
                <StepHeading number="2" title="Cleaning Location" data-id="element-1709" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-1710">
                  <input type="text" placeholder="Enter a location" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1711" />
                  <input type="text" placeholder="Unit/Apt/Suite #" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1712" />
                  <input type="text" placeholder="City" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1713" />
                  <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1714" />
                </div>
                <div className="ml-0 md:ml-14 mt-4" data-id="element-1715">
                  <a href="#" className="text-accent hover:text-primary transition-colors flex items-center gap-2 font-medium" data-id="element-1716">
                    See what's included in our Move-In / Move-Out Cleaning
                    service <Info size={16} data-id="element-1717" />
                  </a>
                </div>
              </section>

              {/* STEP 3 */}
              <section data-id="element-1718">
                <StepHeading number="3" title="Tell us about the cleaning" data-id="element-1719" />
                <div className="space-y-8 ml-0 md:ml-14" data-id="element-1720">
                  <div data-id="element-1721">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1722">
                      How many hours and cleaners would you like to book?
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1723">
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1724">
                        <option data-id="element-1725">2 Hours</option>
                        <option data-id="element-1726">3 Hours</option>
                        <option data-id="element-1727">4 Hours</option>
                        <option data-id="element-1728">5 Hours</option>
                        <option data-id="element-1729">6 Hours</option>
                        <option data-id="element-1730">7 Hours</option>
                        <option data-id="element-1731">8 Hours</option>
                      </select>
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1732">
                        <option data-id="element-1733">1 Cleaner</option>
                        <option data-id="element-1734">2 Cleaners</option>
                        <option data-id="element-1735">3 Cleaners</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-1736">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1737">
                      Move Type
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-1738">
                      {['Move-In', 'Move-Out'].map(opt => <button key={opt} type="button" onClick={() => setMoveType(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${moveType === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1739">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1740">
                    <label className="text-primary font-medium text-lg" data-id="element-1741">
                      Bedrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1742">
                      <option data-id="element-1743">Studio / 1 Bedroom</option>
                      <option data-id="element-1744">2 Bedrooms</option>
                      <option data-id="element-1745">3 Bedrooms</option>
                      <option data-id="element-1746">4 Bedrooms</option>
                      <option data-id="element-1747">5+ Bedrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1748">
                    <label className="text-primary font-medium text-lg" data-id="element-1749">
                      Bathrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1750">
                      <option data-id="element-1751">1 Bathroom</option>
                      <option data-id="element-1752">2 Bathrooms</option>
                      <option data-id="element-1753">3 Bathrooms</option>
                      <option data-id="element-1754">4+ Bathrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1755">
                    <label className="text-primary font-medium text-lg" data-id="element-1756">
                      Additional Rooms (dining rooms, living room, office, etc)
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1757">
                      <option data-id="element-1758">No additional rooms</option>
                      <option data-id="element-1759">1 Room</option>
                      <option data-id="element-1760">2 Rooms</option>
                      <option data-id="element-1761">3 Rooms</option>
                      <option data-id="element-1762">4+ Rooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1763">
                    <label className="text-primary font-medium text-lg" data-id="element-1764">
                      Number of Floors (incl basement)
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1765">
                      <option data-id="element-1766">1 Floor</option>
                      <option data-id="element-1767">2 Floors</option>
                      <option data-id="element-1768">3 Floors</option>
                      <option data-id="element-1769">4+ Floors</option>
                    </select>
                  </div>

                  <div data-id="element-1770">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1771">
                      Parking
                    </label>
                    <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-1772">
                      {['Free on street', 'Free home parking', 'Parking meters', 'Paid parking lot'].map(opt => <button key={opt} type="button" onClick={() => setParking(opt)} className={`flex-1 min-w-[140px] py-3.5 px-4 text-sm font-medium transition-all duration-300 ${parking === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-1773">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-1774">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1775">
                      Do you have any pets? (Required for safety & allergy
                      reasons)
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-1776">
                      {['None', 'Dog', 'Cat'].map(opt => <button key={opt} type="button" onClick={() => setPets(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${pets === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1777">
                          {opt}
                        </button>)}
                    </div>
                  </div>
                </div>
              </section>

              {/* STEP 4 */}
              <section data-id="element-1778">
                <StepHeading number="4" title="Move-In / Move-Out Extras" subtitle="Free up more of your precious time for what matters most!" data-id="element-1779" />
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ml-0 md:ml-14" data-id="element-1780">
                  {extrasList.map(({
                  id,
                  label,
                  icon: Icon
                }) => {
                  const isSelected = selectedExtras.includes(id);
                  return <button key={id} type="button" onClick={() => toggleExtra(id)} className={`flex flex-col items-center justify-center p-6 rounded-2xl border-2 transition-all duration-300 group ${isSelected ? 'border-accent bg-accent/5 shadow-md' : 'border-gray-100 bg-gray-50 hover:border-accent/30 hover:bg-gray-100'}`} data-id="element-1781">
                        <div className={`mb-4 transform transition-transform duration-300 ${isSelected ? 'scale-110' : 'group-hover:scale-105'}`} data-id="element-1782">
                          <Icon data-id="element-1783" />
                        </div>
                        <span className={`text-sm text-center font-medium ${isSelected ? 'text-primary font-bold' : 'text-gray-600'}`} data-id="element-1784">
                          {label}
                        </span>
                      </button>;
                })}
                </div>
              </section>

              {/* STEP 5 */}
              <section data-id="element-1785">
                <StepHeading number="5" title="Select Frequency" data-id="element-1786" />
                <div className="ml-0 md:ml-14" data-id="element-1787">
                  <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-1788">
                    {['One time'].map(opt => <button key={opt} type="button" onClick={() => setFrequency(opt)} className={`flex-1 py-4 px-4 text-sm font-medium transition-all duration-300 ${frequency === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1789">
                        {opt}
                      </button>)}
                  </div>
                </div>
              </section>

              {/* STEP 6 */}
              <section data-id="element-1790">
                <StepHeading number="6" title="Date of service" subtitle="For recurring services, each one will commence on the same day and time as selected for the first service." data-id="element-1791" />
                <div className="ml-0 md:ml-14 space-y-8" data-id="element-1792">
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1793">
                    <span className="font-bold text-primary mb-3" data-id="element-1794">
                      Choose a timezone
                    </span>
                    <div className="flex items-center gap-3" data-id="element-1795">
                      <span className="text-gray-500 text-sm" data-id="element-1796">
                        Our Company's
                      </span>
                      <div className="w-12 h-6 bg-accent rounded-full relative cursor-pointer" data-id="element-1797">
                        <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" data-id="element-1798"></div>
                      </div>
                      <span className="text-primary font-medium text-sm" data-id="element-1799">
                        Yours
                      </span>
                    </div>
                  </div>

                  <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-1800">
                    <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50" data-id="element-1801">
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-1802">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1803">
                          <circle cx="12" cy="12" r="10" data-id="element-1804"></circle>
                          <polyline points="12 8 8 12 12 16" data-id="element-1805"></polyline>
                          <line x1="16" y1="12" x2="8" y2="12" data-id="element-1806"></line>
                        </svg>
                      </button>
                      <div className="flex gap-2 sm:gap-6 overflow-x-auto px-2 hide-scrollbar" data-id="element-1807">
                        {dates.map(d => <button key={d.date} type="button" onClick={() => setSelectedDate(d.date)} className={`flex flex-col items-center p-2 rounded-lg min-w-[60px] transition-colors ${selectedDate === d.date ? 'bg-accent/10 text-accent' : 'hover:bg-gray-100 text-gray-600'}`} data-id="element-1808">
                            <span className="text-sm font-medium mb-1" data-id="element-1809">
                              {d.day}
                            </span>
                            <span className="text-xs flex items-center gap-1" data-id="element-1810">
                              <Calendar size={12} data-id="element-1811" />
                              {d.date}
                            </span>
                          </button>)}
                      </div>
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-1812">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1813">
                          <circle cx="12" cy="12" r="10" data-id="element-1814"></circle>
                          <polyline points="12 16 16 12 12 8" data-id="element-1815"></polyline>
                          <line x1="8" y1="12" x2="16" y2="12" data-id="element-1816"></line>
                        </svg>
                      </button>
                    </div>

                    <div className="p-6 bg-white flex flex-col items-end gap-3" data-id="element-1817">
                      {['14:00', '15:00'].map(time => <button key={time} type="button" onClick={() => setSelectedTime(time)} className={`flex items-center gap-2 px-6 py-2 rounded-full border transition-all ${selectedTime === time ? 'border-accent bg-accent text-white shadow-md' : 'border-gray-200 text-accent hover:border-accent hover:bg-accent/5'}`} data-id="element-1818">
                          <Clock size={16} data-id="element-1819" />
                          {time}
                        </button>)}
                    </div>
                  </div>

                  <p className="text-gray-500 text-sm italic" data-id="element-1820">
                    For same day bookings, a Customer service agent will call
                    you.
                  </p>

                  <div data-id="element-1821">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1822">
                      Are there any additional details we need to know?
                    </label>
                    <textarea className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all min-h-[120px] text-primary resize-y" data-id="element-1823"></textarea>
                  </div>
                </div>
              </section>

              {/* STEP 7 */}
              <section data-id="element-1824">
                <StepHeading number="7" title="Payment details" subtitle="Select your method of payment. Credit Card charges may be pre-authorised, but applied only after the service event is complete." data-id="element-1825" />
                <div className="ml-0 md:ml-14 space-y-6" data-id="element-1826">
                  <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-1827">
                    {['By Cash', 'By Check', 'By Credit/Debit Card', 'By Interac e-Transfer'].map(opt => <button key={opt} type="button" onClick={() => setPaymentMethod(opt)} className={`flex-1 min-w-[150px] py-4 px-4 text-sm font-medium transition-all duration-300 ${paymentMethod === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-1828">
                        {opt}
                      </button>)}
                  </div>

                  {paymentMethod === 'By Credit/Debit Card' && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} className="space-y-4" data-id="element-1829">
                      <input type="text" placeholder="name on credit card" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1830" />

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1831">
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border-2 border-accent bg-accent/5 text-primary font-medium" data-id="element-1832">
                          <CreditCard className="text-accent" data-id="element-1833" />
                          Card
                        </button>
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-primary font-medium transition-colors" data-id="element-1834">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1835">
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#F5C842" data-id="element-1836" />
                            <path d="M15 10.5H9V13.5H15V10.5Z" fill="#1B1B2F" data-id="element-1837" />
                          </svg>
                          Google Pay
                        </button>
                      </div>

                      <div className="flex items-center gap-2 text-accent text-sm font-bold mt-2" data-id="element-1838">
                        <Lock size={14} data-id="element-1839" />
                        Secure, fast checkout with Link
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1840">
                          <polyline points="6 9 12 15 18 9" data-id="element-1841"></polyline>
                        </svg>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-12 gap-4" data-id="element-1842">
                        <div className="sm:col-span-6 relative" data-id="element-1843">
                          <input type="text" placeholder="Card number" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1844" />
                          <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-1" data-id="element-1845">
                            <div className="w-8 h-5 bg-blue-800 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-1846">
                              VISA
                            </div>
                            <div className="w-8 h-5 bg-orange-500 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-1847">
                              MC
                            </div>
                          </div>
                        </div>
                        <input type="text" placeholder="Expiration date" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1848" />
                        <input type="text" placeholder="Security code" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1849" />
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1850">
                        <select className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1851">
                          <option data-id="element-1852">United Kingdom</option>
                          <option data-id="element-1853">United States</option>
                          <option data-id="element-1854">Canada</option>
                        </select>
                        <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1855" />
                      </div>

                      <p className="text-xs text-gray-500 mt-4 leading-relaxed" data-id="element-1856">
                        By providing your card information, you allow Smith and
                        Jengs Cleaning Services to charge your card for future
                        payments in accordance with their terms.
                      </p>
                      <p className="text-xs text-gray-400 text-center italic mt-2" data-id="element-1857">
                        I authorise the operator to send instructions to the
                        financial institution that issued my card to take
                        payments from my card account in accordance with the
                        terms of my agreement with you.
                      </p>
                    </motion.div>}

                  <div className="space-y-3 pt-6 flex flex-col items-center" data-id="element-1858">
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-1859">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-accent transition-colors" data-id="element-1860">
                        <div className="w-3 h-3 bg-transparent rounded-sm" data-id="element-1861"></div>
                      </div>
                      <span className="text-primary text-lg" data-id="element-1862">
                        I would like to be notified by email.
                      </span>
                    </label>
                  </div>
                </div>
              </section>

              {/* Submit */}
              <div className="pt-12 pb-4 flex justify-center border-t border-gray-100" data-id="element-1863">
                <button type="submit" className="bg-[#5CB85C] hover:bg-[#4cae4c] text-white px-16 py-4 rounded text-xl font-bold transition-all shadow-md hover:shadow-lg" data-id="element-1864">
                  Book Now
                </button>
              </div>
            </form>
          </motion.div>

          {/* Sidebar - Booking Summary */}
          <div className="lg:col-span-4 xl:col-span-3" data-id="element-1865">
            <div className="sticky top-32 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-1866">
              <div className="bg-gray-50 p-6 border-b border-gray-100" data-id="element-1867">
                <h3 className="text-xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-1868">
                  Booking Summary
                </h3>
              </div>

              <div className="p-6 space-y-4 border-b border-gray-100" data-id="element-1869">
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1870">
                  <Calendar size={16} className="text-accent" data-id="element-1871" />
                  <span data-id="element-1872">4 Apr 2026</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1873">
                  <Clock size={16} className="text-accent" data-id="element-1874" />
                  <span data-id="element-1875">14:00</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1876">
                  <RefreshCw size={16} className="text-accent" data-id="element-1877" />
                  <span data-id="element-1878">One time</span>
                </div>
              </div>

              <div className="p-6 space-y-3 border-b border-gray-100 text-sm" data-id="element-1879">
                <div className="flex justify-between text-gray-600" data-id="element-1880">
                  <span data-id="element-1881">Move-In/Move-Out Cleaning</span>
                  <span data-id="element-1882">£50.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-1883">
                  <span data-id="element-1884">DISCOUNTS</span>
                  <span data-id="element-1885">£0.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-1886">
                  <span data-id="element-1887">EXTRAS</span>
                  <span data-id="element-1888">£0.00</span>
                </div>
              </div>

              <div className="p-6 bg-gray-50 flex justify-between items-center" data-id="element-1889">
                <span className="font-bold text-primary text-lg" data-id="element-1890">TOTAL</span>
                <span className="font-bold text-primary text-lg" data-id="element-1891">£50.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}